<template>
  <div class="home">
    <!-- 电子书 -->
    <div class="eachClassify">
      <div class="classifyHead">电子书</div>
      <el-input
        @focus="toSearch"
        class="headSearch"
        prefix-icon="el-icon-search"
        size="medium"
        v-model="input"
        placeholder="搜索"
      ></el-input>
      <div class="eachBookList">
        <div
          @click="toEachClassify(item.bookId)"
          v-for="(item, index) in ebookArr"
          :key="index"
          class="eachBook"
        >
          <img :src="item.cover" />
          <div class="bookName">{{ item.bookName }}</div>
        </div>
      </div>
    </div>

    <FootTab></FootTab>
  </div>
</template>

<script>
import FootTab from "@/components/FootTab.vue";
export default {
  name: "home",
  components: {
    FootTab,
  },
  data() {
    return {
      title: "",
      listArr: [],
      ebookArr: [],
      input: "",
    };
  },
  created() {},
  mounted() {
    var that = this;
    // 获取分类
    that.http.getList().then((res) => {
      that.listArr = res.data.data;
    });
    that.http
      .getEbookListX({
        pageSize: 100,
        pageNo: 1,
        apiCode:"zhongguangshe",
      })
      .then((res) => {
        console.log(res.data.data, "电子书");
        that.ebookArr = res.data.data;
      });
  },
  methods: {
    toSearch() {
      this.$router.push({
        name: "search",
      });
      this.scroll = this.$refs.home.scrollTop;
    },
    toEachClassify(id) {
      this.$router.push({
        path: "/bookdetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-input__prefix {
  top: 1px !important;
}
::v-deep .el-input__inner {
  border-radius: 50px !important;
  padding: 0px 30px !important;
}
.home {
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 1.46rem;
  text-align: left;

  .eachClassify {
    padding: 0px 0.44rem;

    .classifyHead {
      text-align: center;
      font-size: 0.38rem;
      color: #151515;
      font-weight: bold;
      padding: 0.2rem;
    }
    .eachBookList {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      // justify-content: space-between;
      margin-top: 0.36rem;

      .eachBook {
        width: 1.87rem;
        margin-bottom: 0.34rem;
        margin-right: 0.412rem;

        img {
          display: block;
          width: 100%;
          height: 2.45rem;
          margin-bottom: 0.15rem;
        }
        .bookName {
          text-align: center;
          font-size: 0.28rem;
          color: #151515;
          line-height: 0.32rem;
        }
      }

      .eachBook:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
